import { IVehicle } from "../../interfaces/session/IVehicle";

export function getVehicleWithFitmentOptions(vehicle: IVehicle) {
  const {
    make, model, year, fitmentOptions,
  } = vehicle;
  const fitmentOptionsWithValue = fitmentOptions?.map((option) => ({
    optionValue: option.optionValue,
    optionName: option.optionName,
  }));
  return {
    make, model, year, fitmentOptions: fitmentOptionsWithValue,
  };
}
